module.exports = __webpack_public_path__ + "img/FW_Plantblade.611310eb.png";